<nav mat-tab-nav-bar [tabPanel]="tabPanel" class="tracking-nav" mat-stretch-tabs="false">
  <a mat-tab-link routerLink="tourdetails" routerLinkActive #a="routerLinkActive" [active]="a.isActive">
    <mat-icon fontSet="material-symbols-outlined">local_shipping</mat-icon>
    Tour Details
  </a>

  <a mat-tab-link routerLink="bestellfenster" routerLinkActive #b="routerLinkActive" [active]="b.isActive">
    <mat-icon fontSet="material-symbols-outlined">schedule</mat-icon>
    Bestellfenster
  </a>

  <a mat-tab-link routerLink="aktuelle-meldungen" routerLinkActive #c="routerLinkActive" [active]="c.isActive">
    <mat-icon fontSet="material-symbols-outlined">notifications</mat-icon>
    <span [matBadge]="unreadCount()" matBadgeOverlap="false" matBadgeSize="medium" matBadgeColor="warn"
          [matBadgeHidden]="unreadCount() === 0">
      Aktuelle Meldungen
    </span>
  </a>
</nav>

<mat-tab-nav-panel #tabPanel>
  <router-outlet/>
</mat-tab-nav-panel>
